export default class PdfUtil {
  static openBlob = (blob: Blob) => {
    var url = window.URL.createObjectURL(blob);
    var anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.click();
  }
}